import { HttpEvent, HttpHandlerFn, HttpRequest } from "@angular/common/http";
import { inject } from "@angular/core";
import { Observable } from "rxjs";
import { LoginService } from "../services/login.service";
//import { environment } from "src/environments/environment";
import { whiteList } from './white-list';

export function requestInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
    const token = inject(LoginService).getToken();
    const url = req.url;
    const urlLength = url.split("/").length;

    //const urlToCheck = req.url.replaceAll(environment.BASE_URL, '').replaceAll('entreprise/', '');
    const urlToCheck = url.split("/")[length - 1];

    const newReq = whiteList.find(whiteUrl => whiteUrl === urlToCheck) ? req : req.clone({
        headers: req.headers.append('Token', token),
    });

    return next(newReq);
}